import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';

import { rHandler } from '@/plugins/RHandler';
import { apiService } from '@/services/APIService';

import Exchange from '../list/exchange/index';

export const ExchangeManager = {
  get objects() {
    const path = 'exchanges';
    return objectsRHandler(path, Exchange);
  },
  get own() {
    const path = 'own-exchanges';
    return {
      ...objectsRHandler(path, Exchange),
      createTarget({ args = [], data, obs } = DEFAULT_PARAMS) {
        const [exchangeId] = args;
        return rHandler(
          apiService.post(`${path}/${exchangeId}`, data),
          (response) => ({
            response,
            item: new Exchange(response.data.data, path),
          }),
          (error) => ({ error }),
          obs,
        );
      },
      organizers({ args = [], params } = DEFAULT_PARAMS) {
        const [exchangeId] = args;
        return rHandler(
          apiService.get(`${path}/${exchangeId}/organizers`, params),
          (response) => ({
            response,
            items: response?.data?.data || [],
          }),
          (error) => ({ error }),
        );
      },
      confirm({ args = [], data, obs } = DEFAULT_PARAMS) { // confirmOrganization
        const [exchangeId] = args;
        return rHandler(
          apiService.post(`${path}/${exchangeId}/confirm`, data),
          (response) => ({
            response,
            item: response?.data?.data,
          }),
          (error) => ({ error }),
          obs,
        );
      },
    };
  },
};
